/** Origin the add-in itself is served from. */
export const getRootAddinUrl = (): string => {
  const url = new URL(window.location.href);
  return url.origin;
};
